import benchmarks from 'api/benchmarks';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import { showSuccess } from 'helpers/showSuccess';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from 'routes';
import { Benchmark } from 'types/Benchmark';

type Properties = {
  benchmark: Benchmark;
  visible: boolean;
  onClose: () => void;
};

export const DeleteModal = (properties: Properties) => {
  const { benchmark, visible, onClose } = properties;
  const history = useHistory();

  const { mutate: deleteMutate, isLoading: deleteIsLoading } =
    benchmarks.DeleteBenchmark();

  const deleteBenchmark = (id: string | undefined) => {
    if (id) {
      deleteMutate(id, {
        onSuccess: () => {
          onClose();
          history.push(routes.getBenchmarksRoute());
          showSuccess(`Your benchmark has been deleted.`);
        },
      });
    }
  };

  useEffect(() => {}, [deleteIsLoading]);

  return (
    <ConfirmModal
      testid='deleteBenchmarkModal'
      title='Delete Benchmark'
      show={visible}
      size='md'
      confirmLabel='Delete'
      onClose={onClose}
      onConfirm={() => deleteBenchmark(benchmark.id)}
      isCentered={true}
      message="Are you sure you'd like to delete this benchmark?"
      isLoading={deleteIsLoading}
    ></ConfirmModal>
  );
};
